import { useEffect, useMemo, useState } from "react";
import multicall from "contracts/Multicall";
import { useMoralis } from "react-moralis";

export const useMulticall = () => {
  const { chainId } = useMoralis();
  const [contract, setContract] = useState();

  useEffect(() => {
    setContract(multicall);
    return () => {
      setContract(null);
    };
  }, []);

  const isDeployedToActiveChain = useMemo(() => {
    if (!contract?.networks) return undefined;
    return [parseInt(chainId, 16)] in contract.networks;
  }, [contract, chainId]);

  return useMemo(() => {
    if (!isDeployedToActiveChain) return { name: multicall.name, address: "", abi: multicall.abi };
    return {
      name: multicall.name,
      address: contract.networks[parseInt(chainId, 16)]?.["address"] || "",
      abi: multicall.abi,
    };
  }, [chainId, contract, isDeployedToActiveChain]);
};
